import React from 'react';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';

import { WorkflowDiagramViewModal, type Props } from './main.tsx';

export const APP_NAME = 'jiraWorkflowViewDiagramModal';

export const WorkflowViewDiagramApp = (props: Props) => {
	return (
		<ContextualAnalyticsData sourceName="workflow-view-diagram-modal" sourceType={MODAL}>
			<WorkflowDiagramViewModal {...props} />
		</ContextualAnalyticsData>
	);
};

export default WorkflowViewDiagramApp;
